import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ReactivationCampaignType,
  ReactivationDetails,
  ReactivationScenario,
  ReactivationSubscriptionDetails,
} from 'src/services/reactivation.types';

export interface ReactivationStateType {
  scenario: ReactivationScenario | null;
  subscription: ReactivationSubscriptionDetails | null;
  paymentMethod: ReactivationDetails['paymentMethod'];
  shouldOnlyReactivateSubscription: boolean;
  campaignType: ReactivationCampaignType | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ReactivationStateType = {
  scenario: null,
  subscription: null,
  paymentMethod: null,
  shouldOnlyReactivateSubscription: false,
  campaignType: null,
  isLoading: false,
  error: null,
};

export const reactivationSlice = createSlice({
  name: 'reactivation',
  initialState,
  reducers: {
    setReactivationDetails: (
      state,
      action: PayloadAction<ReactivationDetails>
    ) => {
      state.scenario = action.payload.scenario;
      state.subscription = action.payload.subscription;
      state.paymentMethod = action.payload.paymentMethod;
      state.shouldOnlyReactivateSubscription =
        action.payload.shouldOnlyReactivateSubscription ?? false;
      state.campaignType = action.payload.campaignType ?? null;
      state.isLoading = false;
      state.error = null;
    },
    setReactivationLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setReactivationError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearReactivationState: state => {
      state.scenario = null;
      state.subscription = null;
      state.paymentMethod = null;
      state.shouldOnlyReactivateSubscription = false;
      state.campaignType = null;
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  setReactivationDetails,
  setReactivationLoading,
  setReactivationError,
  clearReactivationState,
} = reactivationSlice.actions;

export default reactivationSlice.reducer;
